import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['erp', 'field']

  connect() {
    this.toggle()
  }

  toggle() {
    this.fieldTargets.forEach((field) => {
      const shown = field.dataset.erp === this.erpTarget.value
      field.classList.toggle('hidden', !shown)
      field.querySelectorAll('input').forEach((input) => {
        input.disabled = !shown
      })
    })
  }
}
